export const REACT_APP_AIIMS_URL = "https://www.aiimsmangalagiri.edu.in/";

export const REACT_APP_LOGO_URL = "https://www.aiimsmangalagiri.edu.in/wp-content/uploads/2024/06/AIIMS_MANGALAGIRI_COLOUR-28.10.21.png";

export const CONTACT_EMAIL = "estt@aiimsmangalagiri.edu.in";

export const REC_EMAIL = "recruitment.helpdesk@aiimsmangalagiri.edu.in"

export const STUDENT_ADMISSION_EMAIL1 = "dean.ahs@aiimsmangalagiri.edu.in";

export const STUDENT_ADMISSION_EMAIL2 = "dranilreddy@aiimsmangalagiri.edu.in";

export const REACT_APP_SERVER_URL = "https://aiimsmg.duckdns.org/api";

export const IMAGE_CERT = ["photo", "signature"];

